import { setCookie, getCookie, eraseCookie } from './cookies';

let cookieRecentProducts = getCookie('recently_viewed');

// Recently Viewed
if ($('.js-product-id').length) {
	let getProductId = $('.js-product-id').data('handle');
	// if for first time on product page
	if (!cookieRecentProducts) {
		setCookie('recently_viewed', getProductId, 1);
	} else {
		// if already visited product page and visiting again
		const getCookieVal = cookieRecentProducts;
		const arr = getCookieVal.split(',');
		const newArr = [...arr];
		if (newArr.indexOf(getProductId) === -1) {
			newArr.push(getProductId);
		}
		if (newArr.length > 3) {
			newArr.shift();
		}

		setCookie('recently_viewed', newArr, 1);
	}
}

if ($('.section-recent').length && cookieRecentProducts) {
	const recentProducts = cookieRecentProducts.split(',');
	recentProducts.forEach(function(item) {
		$.ajax({
			url: '/products/' + item + '.js',
			type: 'GET',
			dataType: 'json'
		})
			.done(function(product) {
				let productImage = product.featured_image;
				let productImageAlt = product.title;
				let productType = product.type;
				let productVariant = product.variants[0].title;
				let productPrice = formatPrice(product.price);
				let productUrl = product.url;
				let textHtml = '';

				if (productType) {
					textHtml = `<span>${product.type}</span>`;
				}
				if (productVariant) {
					textHtml += `<span>${product.title}</span>`;
				} else {
					textHtml += `<span>${productVariant}</span>`;
				}

				const html = `
				<div class="recent-product">
				   <div class="product__inner">
				   	<a href="${productUrl}" class="product__link"></a>

				   	<div class="product__image" style="background-image: url(${productImage})">
				   	</div>

				    <div class="product__entry">
				    	<h3 class="product__info">${textHtml}</h3>

				    	<p class="product__price">
				    		<span class="money">${productPrice}</span>
				    	</p>
				    </div>
				   </div>
				</div>`;

				$('.js-recent-products').append(html);
				$('.section-recent').addClass('initialize-section');
			})
			.fail(function() {
				console.log('error');
			});
	});
}

function formatPrice(cents) {
	return (cents / 100).toLocaleString('en-GP', {
		style: 'currency',
		currency: 'GBP'
	});
}
